<template>
  <div
    class="detail_main bg_detail is-scrollable has-background-color-background padding_medium">
    <div class="topVert">
      <label class="is-italic has-text-default p_size14">
        Sujet du message
        <label class="errorBorder">(Obligatoire)</label>
      </label>
      <b-field
        class="top5 bottomVert"
        :type="typeSujet"
        :message="errorSujet"
      >
        <b-input rows="2" v-model="sujet"></b-input>
      </b-field>
      <label class="is-italic has-text-default p_size14">
        Vos modifications
        <label class="errorBorder">(Obligatoire)</label>
      </label>
      <b-field
        class="top5 bottomVert"
        :type="typeMess"
        :message="errorMess"
      >
        <b-input rows="10" v-model="message" type="textarea"></b-input>
      </b-field>
      <a
        @click="envoyer()"
        class="button is-primary is-rounded is-fullwidth p_size14 bottomViolet">
        <p>Envoyer</p>
        <b-icon
          icon="send"
          size="small"
          class="">
        </b-icon>
      </a>
      <a
        class="button is-rounded is-fullwidth p_size14 has-text-grey"
        @click="$parent.showModalDemande = false"
      >
        Annuler
      </a>
    </div>

    <b-modal v-model="isValidModalActive">
      <div class="card modalSpace">
        <div>
          <div class="columns is-mobile is-marginless">
            <div class="media centre">
              <img src="@/assets/img/icon_demande_d_envoi.png" alt="">
            </div>
          </div>
          <div class="columns is-mobile is-marginless">
            <h2 class="media centre has-text-weight-bold">Demande envoyée</h2>
          </div>
          <div class="columns is-mobile is-marginless">
            <div class="media centre">
              <p class="p_size14">La proposition à bien été envoyé à <br>
              <strong class="leftViolet has-text-primary">{{email}}</strong>
            </p>
            </div>
          </div>
        </div>
        <div class="columns is-mobile topViolet">
          <div @click="close()" class="media centre is-grey is-paddingless">
            <a class="button buttonPadding is-primary is-rounded p_size14">
              Fermer</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { sendModifidationEmail } from '@/services/mail/sendEmail';

export default {
  name: 'modalDemande',
  props: ['date', 'commercial', 'client', 'themeCampagne', 'email'],
  data: () => ({
    sujet: 'Je souhaite une modification sur la proposition',
    typeSujet: '',
    errorSujet: '',
    message: '',
    typeMess: '',
    errorMess: '',
    isValidModalActive: false,
  }),
  methods: {
    verifSujet() {
      if (this.sujet) {
        this.errorSujet = '';
        this.typeSujet = '';
        return true;
      }
      this.typeSujet = 'errorBorder';
      this.errorSujet = 'Veuillez renseigner ce champ';
      return false;
    },
    verifMess() {
      if (this.message) {
        this.errorMess = '';
        this.typeMess = '';
        return true;
      }
      this.typeMess = 'errorBorder';
      this.errorMess = 'Veuillez renseigner ce champ';
      return false;
    },
    envoyer() {
      if (this.verifSujet() && this.verifMess()) {
        this.isValidModalActive = true;
        sendModifidationEmail(
          this.sujet, this.message, this.$route.params.id,
          this.commercial, this.client.nom, this.client.societe, this.themeCampagne);
      }
    },
    close() {
      this.isValidModalActive = false;
      this.$parent.showModalDemande = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/composants/modal/demande.vue